class ModuleTypeHelper {
  static MODULE_KEYS = ['lower', 'upper', 'ceiling'];

  /**
   * Lấy key (lower | upper | ceiling) từ moduleType
   * @param {string} moduleType
   * @returns {'lower' | 'upper' | 'ceiling' | null}
   */
  static getKey(moduleType = '') {
    if (!moduleType) return null;

    const parts = String(moduleType)
      .toLowerCase()
      .split(/[^a-z0-9]+/g); // tách theo _ - space ...

    return this.MODULE_KEYS.find(key => parts.includes(key)) || null;
  }

  /**
   * So sánh 2 moduleType có cùng key hay không
   * @param {string} a
   * @param {string} b
   * @returns {boolean}
   */
  static isSameKey(a, b) {
    const keyA = this.getKey(a);
    const keyB = this.getKey(b);

    if (!keyA || !keyB) return false;
    return keyA === keyB;
  }

  /**
   * So sánh theo key, fallback về so sánh exact nếu không parse được
   * @param {string} a
   * @param {string} b
   * @returns {boolean}
   */
  static isSameKeyOrExact(a, b) {
    const keyA = this.getKey(a);
    const keyB = this.getKey(b);

    if (keyA && keyB) {
      return keyA === keyB;
    }

    return a === b;
  }
}

export default ModuleTypeHelper;
